import React from 'react';
import PropTypes from 'prop-types';
import WarningLabel from "./WarningLabel";

const WarningList = ({ warnings }) => {
  const warningLabels = warnings.map((warning) => <WarningLabel key={warning} warning={warning} />);

  return (
    <div data-label="warning-list" style={{ maxHeight: "150px", overflowY: "scroll" }}>
      {warningLabels}
    </div>
  );
};

WarningList.propTypes = {
  warnings: PropTypes.array.isRequired
};

export default WarningList;
